<template>
  <div class="step-tipo-campanha">
    <!-- Tipo de Campanha (validação) -->
    <div class="step-tipo-campanha__section">
      <div class="section-label">Tipo de campanha</div>
      <TipoCampanhaCards
        :value="item.validacao"
        :disabled="isErpLocked"
        @input="onValidacaoChange"
      />
      <div class="message">{{ validacao.firstError("item.validacao") }}</div>
    </div>

    <!-- Validação valores (quando não usa validação por regra) -->
    <div v-if="!item.validarPorRegra" class="step-tipo-campanha__section">
      <div class="section-label">Valores de validação</div>
      <TipoValidacao
        :item="item"
        :inputShouldBeVisible="inputShouldBeVisible"
        :validacao="validacao"
        :disabled="isErpLocked"
      />
    </div>
  </div>
</template>

<script>
import TipoCampanhaCards from "../shared/TipoCampanhaCards.vue";
import TipoValidacao from "../components/Regra/TipoValidacao.vue";

export default {
  name: "StepTipoCampanha",
  components: {
    TipoCampanhaCards,
    TipoValidacao,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    validacao: {
      type: Object,
      required: true,
    },
    isErpLocked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tiposInputs: {
        QT: ["qtdeMin", "qtdeMax"],
        QD: ["qtdeMinDistinta", "qtdeMaxDistinta"],
        VD: ["vlMin", "vlMax", "qtdeMinDistinta", "qtdeMaxDistinta"],
        VQ: ["vlMin", "vlMax", "qtdeMin", "qtdeMax"],
        VL: ["vlMin", "vlMax"],
        QQ: ["qtdeMin", "qtdeMax", "qtdeMinDistinta", "qtdeMaxDistinta"],
        XX: [
          "vlMin",
          "vlMax",
          "qtdeMinDistinta",
          "qtdeMaxDistinta",
          "qtdeMin",
          "qtdeMax",
        ],
        PM: ["percMin", "percMax"],
        PMD: ["percMin", "percMax"],
      },
    };
  },
  watch: {
    "item.validarPorRegra"() {
      this.resetValidationValues();
      if (Array.isArray(this.item.dimensoes)) {
        this.item.dimensoes.forEach((dimensao) => {
          dimensao.qtdeMin = 0;
          dimensao.qtdeMax = null;
          dimensao.qtdeMinDistinta = 0;
          dimensao.qtdeMaxDistinta = null;
          dimensao.vlMin = 0;
          dimensao.vlMax = 0;
          dimensao.percMin = 0;
          dimensao.percMax = 0;
        });
      }
    },
  },
  methods: {
    inputShouldBeVisible(inputName) {
      return (
        this.tiposInputs[this.item.validacao] &&
        this.tiposInputs[this.item.validacao].indexOf(inputName) >= 0
      );
    },
    onValidacaoChange(value) {
      if (value === this.item.validacao) return;

      const temRegras =
        (Array.isArray(this.item.dimensoes) && this.item.dimensoes.length > 0) ||
        (Array.isArray(this.item.mixProdutos) && this.item.mixProdutos.length > 0);

      if (temRegras) {
        this.$swal({
          title: "Alterar tipo de campanha?",
          text: "As regras configuradas serão removidas ao alterar o tipo de campanha.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Alterar",
          cancelButtonText: "Cancelar",
        }).then((res) => {
          if (res.value) {
            this.item.dimensoes = [];
            this.item.mixProdutos = [];
            this.item.validacao = value;
            this.resetValidationValues();
          }
        });
      } else {
        this.item.validacao = value;
        this.resetValidationValues();
      }
    },
    resetValidationValues() {
      this.item.qtdeMin = 0;
      this.item.qtdeMax = null;
      this.item.qtdeMinDistinta = 0;
      this.item.qtdeMaxDistinta = null;
      this.item.vlMin = 0;
      this.item.vlMax = 0;
      this.item.percMin = 0;
      this.item.percMax = 0;
    },
  },
};
</script>

<style scoped>
.step-tipo-campanha__section {
  margin-bottom: 14px;
}

.section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}
</style>
